import template from './episodechangereport.html';
import controller from './episodechangereport.controller';
import './episodechangereport.styl';

let episodechangereportComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default episodechangereportComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/episodechangereport/episodechangereport.component.js